import { GET_POI_VIEW_DATA, RESET_POI_VIEW_DATA } from "../../actionTypes/actionsTypes";
import { ActionPayload, AppAction, AppNoApiAction, BaseAsyncReducerState } from "../../types";

export interface POIViewDataState extends BaseAsyncReducerState {
    fields: [],
    subprop: Record<string, unknown>,
    poiprops: []
}

// Define an initial state value for the app
const initialState: POIViewDataState  = {
    loading: false,
    error: false,
    fields: [],
    subprop: {},
    poiprops: []
}


function POIViewDataReducer(state = initialState, action: AppAction | AppNoApiAction) {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case GET_POI_VIEW_DATA.PENDING:
            return {
                ...state,
                loading: true,
                error: false
            }
        case GET_POI_VIEW_DATA.SUCCESS:
            return {
                ...state,
                ...payload as ActionPayload,
                loading: false,
                error: false

            }
        case GET_POI_VIEW_DATA.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case RESET_POI_VIEW_DATA:
            return {
                ...state,
                ...initialState
            };
        default:
            return state
        }
}

export default POIViewDataReducer;